import React from 'react';

import useAdditionalContactO15Other from './UseAdditionalContactO15Other';
import AdditionalContactsGrid from '../AdditionalContactsGrid';
import DeleteContactModalInfo from '../DeleteContactModalInfo';

import Views from '../../../Views';
import ViewTemplate from '../../../components/viewTemplate/ViewTemplate';

import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

const AdditionalContactO15Other = () => {
  const {
    onEdit,
    onDeleteConfirmed,
    onNextButtonClicked,
    onAddAdditionalContact,
    modalState,
    onModalCanceled,
    onDeleteClicked,
    onNavigateToEmergencyContact,
    onBackButtonClicked
  } = useAdditionalContactO15Other();

  return (
    <ViewTemplate
      viewName={Views.ADDITIONAL_CONTACTS_O15_OTHER}
      onBackButtonClicked={onBackButtonClicked}
      onNextButtonClicked={onNextButtonClicked}>
      <ActionIntraPageButton onClick={onAddAdditionalContact}>Add Contact</ActionIntraPageButton>
      <AdditionalContactsGrid
        onEdit={onEdit}
        onDeleteClicked={onDeleteClicked}
        onNavigateToEmergencyContact={onNavigateToEmergencyContact} />
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        <DeleteContactModalInfo modalState={modalState} />
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;&nbsp;
            <PrimaryButton type="button" onClick={(e) => { onDeleteConfirmed(e, modalState.itemIndex); }}>Delete</PrimaryButton>
          </div>
        </div>
      </PopUpModal>
    </ViewTemplate>
  );
};

export default AdditionalContactO15Other;